export default {
  businessType: 'Business Type',
  searchDate: 'Date',
  summary: 'Summary',
  vendor: 'Vendor',
  solution: 'Solution',
  detail: 'Detail',
  plant: 'Plant',
  cartonUnitAccuracy: 'Carton & Unit  Accuracy',
  giedASNQty: 'GIed/ASN Qty (Carton)',
  scannedQty: 'Scanned Qty (Carton)',
  noScan: 'No Scan (Carton)',
  accurate: 'Accurate (Carton)',
  scanMissed: 'EPC Shortage (Carton)',
  scanExceeded: 'EPC Overage (Carton)',
  misMatched: 'UPC Mismatched (Carton)',
  byCartonAccuracy: 'By Carton Accuracy',
  tunnelException: 'Tunnel Exception',
  noReadQty: 'No Read Qty (EPC)',
  noDataQty: 'No Data Qty (Carton)',
  noDataRate: 'No Data Rate',
  tunnelMachine: 'Tunnel Machine',
  cartonPE: 'Carton PE',
  dataDefinition: 'Data Definition',
  definition1: `* This report does not include data from Trans Hub or ADC.`,
  definition2: `Carton & Unit Accuracy`,
  definition3: `
    GIed/ASN Qty (Carton): Aggregated GIed or ASN Carton quantity by plant, in carton, based on user selection on business type.
    <br/>
    No Scan (Carton): Aggregated Carton quantity not scanned in tunnel while exist in ASN/GI, in carton.
    <br/>
    Scanned Qty (Carton): Aggregated Carton quantity scanned and recorded via tunnel machine by plant/tunnel machine (by vendor, specifically for 1027 outbound tunnel machine), in carton.
    <br/>
    Accurate (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record, while all UPC quantities are matched, in carton.
    <br/>
    UPC Missed (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record, while scanned UPC quantity is less than the ASN/GI UPC quantity, in carton.
    <br/>
    UPC Exceeded (Carton):  Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record,
    while scanned UPC quantity is greater than the ASN/GI UPC quantity, in carton.
    <br/>
    UPC Mismatched (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record,
    while scanned UPC does not belong to this Carton Number or does not belong to this ASN, or if the carton does not meet Scan missed/exceeded conditions, in carton.
    <br/>
    By Carton Accuracy = Accurate (Carton) / GIed/ASN Qty (Carton)`,
  definition4: `
Tunnel Exception`,
  definition5: `
    No Data Qty (Carton): Aggregated Carton quantity scanned by tunnel while has no EPC number on it, in carton.
    <br/>
    No Data Rate = No Data Qty (Carton) / GIed/ASN Qty (Carton)`,
  exportExceptions: 'Export Exceptions',
  multipleErr: 'allow multiple selection for IB – Factory, IB – STO'
}
